export const joinQueryParams = (paramsObj) => {
    const queryParams = [];
    for (const name in paramsObj) {
        const encodedName = encodeURIComponent(name);
        const encodedValue = encodeURIComponent(paramsObj[name]);
        queryParams.push(`${encodedName}=${encodedValue}`);
    }
    return queryParams.join('&');
};

export const defaultArcQueryParams = Object.freeze({
    where: '1=1',
    outfields: '*',
    f: 'geojson',
});

export const gis2QueryUrl = (layerName, layerId, queryParams = {}) => {
    return `https://gis.london.gov.uk/arcgis/rest/services/apps/${layerName}/MapServer/${layerId}/query/?${new URLSearchParams(
        {
            ...defaultArcQueryParams,
            ...queryParams,
        },
    )}`;
};

export const gis2TileUrl = (layerName) => {
    return `https://gis.london.gov.uk/arcgis/rest/services/apps/${layerName}/MapServer/tile/{z}/{y}/{x}`;
};
